var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMutation, useQuery } from '@apollo/client';
import { Button, Card, CardActionArea, CardContent, useMediaQuery, useTheme } from '@mui/material';
import { SnackbarSeverity } from 'common/enums/components/snackbar-severity.enum';
import { CREATE_SUPPORT_REQUEST } from 'common/graphql/mutations/support-request/create-support-request';
import { ACTIVITY_VALIDATION_SUPPORT_REQUESTS } from 'common/graphql/queries/activity-validations/activity-validation-support-requests';
import useDynamicMutation from 'common/hooks/useDynamicMutation';
import CircularProgressMui from 'components/Loading/CircularProgresMui';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { openSnackbar } from 'store/actions';
import history from 'store/history';
import HelperFunctions from 'utils/HelperFunctions';
import Utils from 'utils/Utils';
var SupportRequestPickCard = function (_a) {
    var supportRequest = _a.supportRequest, handleClose = _a.handleClose;
    var theme = useTheme();
    var isMobile = useMediaQuery(theme.breakpoints.down('md'));
    var formatSupportRequestStatus = HelperFunctions.formatSupportRequestStatus;
    var t = useTranslation().t;
    return (_jsx(Card, __assign({ sx: { width: isMobile ? 240 : '100%' } }, { children: _jsx(CardActionArea, __assign({ onClick: function () {
                history.push("/support-request/".concat(supportRequest.id));
                handleClose();
            } }, { children: _jsx(CardContent, { children: _jsxs("div", __assign({ className: "flex flex-col space-y-10 w-full items-center" }, { children: [_jsx("p", { children: supportRequest.description }, void 0), _jsxs("p", __assign({ className: "text-12" }, { children: [_jsxs("span", __assign({ className: "text-grey" }, { children: [t('Дата создания'), ":"] }), void 0), ' ', _jsx("span", { children: Utils.getDateWithRuMonth(supportRequest.createdAt) }, void 0)] }), void 0), _jsxs("p", __assign({ className: "text-12" }, { children: [_jsxs("span", __assign({ className: "text-grey" }, { children: [t('Статус'), ":"] }), void 0), ' ', _jsx("span", { children: formatSupportRequestStatus(supportRequest) }, void 0)] }), void 0)] }), void 0) }, void 0) }), void 0) }), void 0));
};
var GoToActivityValidationSupportRequestDialog = function (_a) {
    var activityValidationId = _a.activityValidationId, activityValidationRequestMessage = _a.activityValidationRequestMessage, activityName = _a.activityName, handleClose = _a.handleClose;
    var dispatch = useDispatch();
    var t = useTranslation().t;
    var _b = useQuery(ACTIVITY_VALIDATION_SUPPORT_REQUESTS, {
        fetchPolicy: 'network-only',
        variables: {
            id: activityValidationId
        }
    }), data = _b.data, loading = _b.loading, error = _b.error;
    var createSupportRequest = function (data) {
        return useMutation(CREATE_SUPPORT_REQUEST, {
            variables: {
                createSupportRequestData: __assign({}, data)
            },
            awaitRefetchQueries: true
        });
    };
    var onError = function (_a) {
        var code = _a.code;
        dispatch(openSnackbar({
            message: code,
            severity: SnackbarSeverity.ERROR
        }));
        handleClose();
    };
    useEffect(function () {
        if (error) {
            onError({ code: error.message });
        }
    }, [error]);
    var _c = useDynamicMutation(createSupportRequest, function () { }, onError), handleExecuteMutation = _c.handleExecuteMutation, createdSupportRequest = _c.data, supportRequestIsBeeingCreated = _c.loading;
    var handleCreateActivityValidationSupportRequest = function () {
        handleExecuteMutation({
            description: t("\u0412\u0430\u043B\u0438\u0434\u0430\u0446\u0438\u044F \u0442\u0440\u0435\u043D\u0438\u0440\u043E\u0432\u043A\u0438") + ' ' + activityName,
            text: activityValidationRequestMessage || t("\u0412\u0430\u043B\u0438\u0434\u0430\u0446\u0438\u044F \u0442\u0440\u0435\u043D\u0438\u0440\u043E\u0432\u043A\u0438") + ' ' + activityName,
            activityValidationId: activityValidationId
        });
    };
    useEffect(function () {
        if (data && data.activityValidation.supportRequests) {
            if (data.activityValidation.supportRequests.length === 0) {
                handleCreateActivityValidationSupportRequest();
            }
            if (data.activityValidation.supportRequests.length === 1) {
                history.push("/support-request/".concat(data.activityValidation.supportRequests[0].id));
                handleClose();
            }
        }
    }, [data]);
    useEffect(function () {
        var _a;
        if (createdSupportRequest && ((_a = createdSupportRequest.createSupportRequest) === null || _a === void 0 ? void 0 : _a.id)) {
            history.push("/support-request/".concat(createdSupportRequest.createSupportRequest.id));
            handleClose();
        }
    }, [createdSupportRequest]);
    if (loading || supportRequestIsBeeingCreated)
        return _jsx(CircularProgressMui, {}, void 0);
    return data && data.activityValidation.supportRequests && data.activityValidation.supportRequests.length > 1 ? (_jsxs("div", __assign({ className: "flex flex-col space-y-20 items-center w-full justify-center" }, { children: [_jsx("div", __assign({ className: "tw-dialog-header" }, { children: t('Выберите обращение в поддержку') }), void 0), data.activityValidation.supportRequests.map(function (supportRequest) {
                return (_jsx(SupportRequestPickCard, { supportRequest: supportRequest, handleClose: handleClose }, supportRequest.id));
            }), _jsx(Button, __assign({ variant: "text", onClick: handleClose }, { children: t('Отмена') }), void 0)] }), void 0)) : null;
};
export default GoToActivityValidationSupportRequestDialog;
